// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kl75N","select":"styles_select__2Iu1v"};